import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import style from './Header.module.scss';
import { useStores } from 'hooks';
import { useHistory } from 'react-router-dom';
import Tooltip from '@material-ui/core/Tooltip';

export default observer(({ isSidebarOpen, setIsSidebarOpen }) => {
  const { authStore } = useStores();
  const history = useHistory();
  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };
  const onClickAccountManagement = () => {
    history.push('/account_management');
  };

  const onLogout = () => {
    authStore.logoutAll();
  };
  const onLogoutToLastID = () => {
    authStore.backToPrevIdentity();
  }

  return (
    <>
      <div className={style.header}>
        <div className={style.menuContainer} onClick={toggleSidebar}>
          <div className={style.menuBtn}>
            <div className={style.burger} />
          </div>
        </div>
        <div
          className={classnames(style.title, { [style.close]: !isSidebarOpen })}
        >
          <div className={style.bigLogo} />
        </div>
      </div>
      <div className={style.topRight}>
        <Tooltip
          title="My Profile"
          arrow
          placement="bottom"
        >
          <button onClick={onClickAccountManagement}>
            <span
              className={style.userProfile}
              style={{
                backgroundImage: `url(${
                  authStore.viewer.avatar ||
                  'https://static.amaz.xyz/emoji/AMAZ+Icon_User.png'
                })`,
              }}
            />
            <span>{authStore.viewer.username}</span>
          </button>
        </Tooltip>
        {authStore.token.length > 1 &&
          <Tooltip
            title="Back to last identity"
            arrow
            placement="bottom"
          >
            <button onClick={onLogoutToLastID}>
              <i className={`fas fa-undo`} style={{ color: 'rgb(26 148 253)'}} />
            </button>
          </Tooltip>}
        <Tooltip
          title="Logout"
          arrow
          placement="bottom"
        >
          <button onClick={onLogout}>
            <i style={{ left: '5px' }} className={`fas fa-sign-out-alt`} />
          </button>
        </Tooltip>
      </div>
    </>
  );
});
